import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'
import { TypographyV2 as Typography } from '@which/seatbelt'

import classnames from 'classnames'

import { singleBrandUrlRegex } from '../../../../../shared/constants/single-brand-ulr-regex'
import { useFullUrl } from '../../../../../shared/hooks/useFullUrl'
import type { ProductCount as ProductCountType } from '../../../../../shared/types/ReviewsFilters'
import { useAppliedFilters } from '../../hooks/useAppliedFilters'
import { ReviewsTemplateContext } from '../../ReviewsTemplateContext'
import { getCategoryInfo } from '../../utils/get-category-info'
import styles from './ProductCount.module.scss'

export const ProductCount: FunctionComponent<ProductCountProps> = ({
  className,
  description,
  start,
  end,
  total,
  ...rest
}) => {
  const { state } = useContext(ReviewsTemplateContext)
  const { filters, needsBasedFilters, meta } = state.productListingPageData
  const { getFullUrl } = useFullUrl()
  const [, maybeBrandName] = getFullUrl().match(singleBrandUrlRegex) || []
  const { appliedFilters } = useAppliedFilters(filters, needsBasedFilters)
  const { name: categoryName } = meta.taxonomyHierarchy.category

  return total > 0 ? (
    <Typography
      data-testid="product-count"
      className={classnames(className, styles.count)}
      tag="p"
      textStyle="sb-text-body-default-regular"
      {...rest}
    >
      <span data-testid="start-count" className={styles.emphasis}>
        {start}
      </span>{' '}
      to{' '}
      <span data-testid="end-count" className={styles.emphasis}>
        {end}
      </span>{' '}
      of{' '}
      <span data-testid="total-count" className={styles.emphasis}>
        {total}
      </span>{' '}
      {
        getCategoryInfo({
          heading: description,
          categoryName,
          appliedFilters,
          brandName: maybeBrandName,
        }).heading
      }
    </Typography>
  ) : null
}

///////// IMPLEMENTATION /////////

export type ProductCountProps = ProductCountType & {
  className?: string
}
